export const anchorScroll = (elementSelector, timeout = 0, offsetTop = 0) => {
  // Push onto callback queue so it runs after the DOM is updated,
  // this is required when navigating from a different page so that
  // the element is rendered on the page before trying to getElementById.
  setTimeout(() => {
    const element = document.querySelector(elementSelector);
    if (element) {
      const elementPosition = element.offsetTop;
      const offsetPosition = elementPosition - offsetTop;
      // Scroll Into View dont support offset
      // which is needed for pages with headers so moved to `scrollTo`
      // element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  }, timeout);
};
